import { MenuItemOptions } from '@modules/common/components/KebabMenu/types';
import { MoreVertRounded } from '@mui/icons-material';
import { IconButton, IconButtonProps, Menu, MenuProps } from '@mui/material';
import { useState } from 'react';
import { FlatMenuListItem } from './FlatMenuListItem';

interface FlatMenuListProps {
  listItems: MenuItemOptions;
  buttonProps?: IconButtonProps;
  menuProps?: Partial<MenuProps>;
}

export const FlatMenuList = ({
  listItems,
  buttonProps = {},
  menuProps,
}: FlatMenuListProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  if (listItems.length === 0) {
    return null;
  }

  const shouldShowDividers = listItems.length > 1;

  const onMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onMenuClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton onClick={onMenuOpen} {...buttonProps}>
        <MoreVertRounded />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onMenuClose}
        {...menuProps}
      >
        {listItems.map((listItem, index) => (
          <FlatMenuListItem
            listItem={listItem}
            menuItemIndex={index}
            key={index}
            shouldShowDividers={shouldShowDividers}
            onMenuClose={onMenuClose}
          />
        ))}
      </Menu>
    </>
  );
};
